export default "__VITE_ASSET__CqGVN_vn__"